import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useTelematicsBoxVehicle(imei) {
  const queryKey = ['telematicsBoxVehicle', imei];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { telematicsBoxImei: imei, deleted: { $exists: false } } },
        {
          $project: {
            _id: false,
            identificationNumber: true,
            registrationNumber: true,
            fleetNumber: true,
            role: true,
            type: true,
            color: true,
            marked: true,
            make: true,
            model: true,
          },
        },
      ];

      const vehicles = await api
        .post('pipeline/vehicles', { json, signal })
        .json();

      return vehicles[0] ?? null;
    },
    placeholderData: null,
    staleTime: 1000 * 60 * 60,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
